export default __webpack_public_path__ + "static/fire_protection_b.268e35d0a11e48b6f024e3166ba81c9c.svg";